<template>
  <!-- <f7-page class="AddContact"> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">

  		<page-nav-bar
        :currentServiceName="$i18n.t('common.appname')"
        :subNavTitle="$i18n.t('common.add_item',
            {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})"
        :returnPreviousPage="isSmartphone"
        :menuAccess="true">
      </page-nav-bar>

         <div class="layoutTop"/>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-10 offset-md-1">
                    <div class="panel21 panel-default">

                      <div class="panel-heading">
                          <h4 class="content-block labelAccordionForm">
                              <i class="fa fa-address-book formIcon"></i>
                              <span>
                                {{ $t('common.add_item',
                                  {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                              </span>
                          </h4>
                      </div>

                      <ul>
                        <div class="accordion-item accordionForm accordion-item-expanded">
                            <a href="#" class="item-content item-link" @click="rotateChevron($event)" v-bind:class="colorBottomButton">
                              <div class="item-inner">
                                <div class="form-group row justify-content-start">
                                    <div class="item-title createInvoiceBand col-sm-auto">
                                      <span class="text-uppercase">
                                        {{ $t('common.formsSubTitle.item_info',
                                          {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                                      </span>
                                      <i class="f7-icons formChevron">chevron_right</i>
                                    </div>
                                </div>
                              </div>
                            </a>

                            <div class="accordion-item-content">
                              <div class="form-group">
                                <div class="custom-control custom-radio custom-control-inline">
                                  <input type="radio" class="custom-control-input" id="defaultInline1" name="inlineDefaultRadiosExample" value="1" v-model="typeContact" checked>
                                  <label class="custom-control-label" for="defaultInline1">{{ $t('common.indiv') }}</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                  <input type="radio" class="custom-control-input" id="defaultInline2" name="inlineDefaultRadiosExample" value="2" v-model="typeContact">
                                  <label class="custom-control-label" for="defaultInline2">{{ $t('common.cmpny') }}</label>
                                </div>
                              </div>
                               <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">
                                     <span class="color-red">* </span>{{ $t('common.nme') }}
                                   </label>
                                   <div class="col-8 col-sm-10">
                                     <input name="name" class="form-control" type="text" :placeholder='benef_name' v-model="name"></input>
                                   </div>
                               </div>
                               <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.als') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="alias" class="form-control" :placeholder="benef_alias" type="text" v-model="label"></input>
                                  </div>
                               </div>
                               <div class="form-group row typeInd" v-if="typeContact === '1'"
                               @click="hideBlock($event)">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.eml') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="identifier" class="form-control" type="email" :placeholder="benef_EmailAddress" v-model="identifier"></input>
                                   </div>
                               </div>
                               <div class="form-group row typeCom" v-else
                               @click="hideBlock($event)">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.srn') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="identifier" class="form-control" type="text" :placeholder="benef_SIREN" v-model="identifier"></input>
                                   </div>
                               </div>
                             </div>
                           </div>
                         </ul>

                          <hr>

                          <ul>
                            <div class="accordion-item accordionForm accordion-item-expanded">
                                <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                                  <div class="item-inner" v-bind:class="colorBottomButton">
                                    <div class="form-group row justify-content-start">
                                        <div class="item-title createInvoiceBand col-sm-auto">
                                          {{ $t('common.formsSubTitle.bank_info') }}
                                          <i class="f7-icons formChevron">chevron_right</i>
                                        </div>
                                    </div>
                                  </div>
                                </a>

                               <div class="accordion-item-content">
                                 <div class="form-group row">
                                   <div class="col-sm-2 col-4 col-form-label labelAccordionForm">
                                     {{ $t('common.act') }}
                                   </div>
                                   <div class="col-sm-4 showSmallScreenOnly form-group" :class='colorBottomButton'>
                                     <div @click="countriesPicker($event)" class="button button-round button-inner-color buttonAccordionForm">
                                       {{ $t('common.slct') }}
                                     </div>
                                   </div>
                                   <div class="col-sm-12 showSmallScreenOnly">
                                     <input
                                      @click="countriesPicker($event)"
                                      class="form-control"
                                      id="ListCountry"
                                      type="text"
                                      v-model="zoneCode"
                                      :placeholder="benef_Selectazone"
                                      readonly>
                                     </input>
                                   </div>
                                   <div class="col-sm-10 showLargeScreenOnly">
                                     <select class="form-control" id="sel4" v-model="zone" readonly>
                                       <option v-for="country in countries" :key="country.id"
                                        :value="country"
                                        :disabled="country.disabled"
                                        :selected="country.selected">
                                        {{ $t(country.label) }}
                                      </option>
                                     </select>
                                   </div>
                                 </div>

                                <div
                                  class="form-group row"
                                  v-for="accountLabel in zone.accountLabel">
                                    <label class="col-4 col-sm-2 col-form-label">
                                      {{ $t(accountLabel) }}
                                    </label>
                                    <div class="col-8 col-sm-10">
                                      <input
                                        name="identifier"
                                        class="form-control"
                                        type="text"
                                        :placeholder="$i18n.t(accountLabel)"
                                        v-model="zone.values[accountLabel]">
                                      </input>
                                    </div>
                                </div>

                                 <div v-if="this.$engine.user.currentService.id === '2'">
                                   <div class="form-group row">
                                     <label class="col-4 col-sm-2 col-form-label">{{ $t('bank_accounts.mandat_id') }}</label>
                                     <div class="col-8 col-sm-10">
                                       <input name="mandatId" class="form-control" type="text" :placeholder="$i18n.t('bank_accounts.mandat_id')"></input>
                                     </div>
                                   </div>
                                   <div class="form-group row">
                                     <label class="col-sm-2 col-4 col-form-label labelAccordionForm" v-bind:class="{redFont: depositExecutionDateColor}">
                                       {{ $t('bank_accounts.mandat_date') }}
                                     </label>
                                     <div class="col-8 col-sm-10">
                                       <input class="form-control" type="date" :placeholder="$i18n.t('bank_accounts.mandat_date')">
                                     </div>
                                   </div>
                                 </div>

                               </div>
                             </div>
                          </ul>
                          <hr>
                          <ul>
                            <div class="accordion-item accordionForm accordion-item-expanded">
                                <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                                  <div class="item-inner" v-bind:class="colorBottomButton">
                                    <div class="form-group row justify-content-start">
                                        <div class="item-title createInvoiceBand col-sm-auto">
                                          {{ $t('common.formsSubTitle.extra_info') }}
                                          <i class="f7-icons formChevron">chevron_right</i>
                                        </div>
                                    </div>
                                  </div>
                                </a>

                               <div class="accordion-item-content">
                                 <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.phn') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="phoneNumber" class="form-control" type="text" :placeholder="benef_PhoneNumber" v-model="phoneNumber"></input>
                                   </div>
                                 </div>
                                 <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.adrs') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="address" class="form-control" type="text" :placeholder="benef_Address" v-model="address"></input>
                                   </div>
                                 </div>
                                 <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.cty') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="city" class="form-control" type="text" :placeholder="benef_City" v-model="city"></input>
                                   </div>
                                 </div>
                                 <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.zp_code') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="zipCode" class="form-control" type="text" :placeholder="benef_ZipCode" v-model="zipCode"></input>
                                   </div>
                                 </div>
                                 <div class="form-group row">
                                   <label class="col-4 col-sm-2 col-form-label">{{ $t('common.ctry') }}</label>
                                   <div class="col-8 col-sm-10">
                                     <input name="cuntry" class="form-control" type="text" :placeholder="benef_Country" v-model="country"></input>
                                   </div>
                                 </div>
                               </div>
                             </div>
                           </ul>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
                      <button round class="button-action firstButtonMarginTop" @click="addContact">
                        <i class="icon fa fa-save"></i>
                        <span>{{ $t('common.sve') }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="toolbarPageBottomBlank"></div>
                  </div>
                </div>
              </div>
            <!-- TLV 15/10/2019 : On cache le bouton Read QR Code pour la démo -->
            <!-- <f7-button class="button-round orangeConfirmationButton" @click="">Read QR Code</f7-button> -->
            <!-- <f7-button disabled icon-f7="cloud_upload" class="blueConfirmationButton">Import Contacts</f7-button> -->
            <!--<div class="toolbarPageBottomBlank"></div> -->
  </div>
  <!-- </f7-page> -->
</template>

<script>
import {validateAccountFormat, validateEmail, validateSIREN, validatePhoneNumber} from '@/helpers/validator'
import {createForeignIban} from '@/helpers/format'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddContact',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      identifier: '',
      name: '',
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '1',
      zone: {
        id: 0,
        label: 'zoneCodes.slct_zone',
        disabled: true,
        selected: true
      },
      zoneCode: '',
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    let that = this
    this.$i18n.t('common.add_item', {itemname: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
    this.benef_name = this.$i18n.t('common.nme')
    this.benef_alias = this.$i18n.t('common.als')
    this.benef_alias = this.$i18n.t('common.als')
    this.benef_EmailAddress = this.$i18n.t('common.eml_adrs')
    this.benef_SIREN = this.$i18n.t('common.srn')
    this.benef_SortCode = this.$i18n.t('common.srt_code')
    this.benef_AccountNumber = this.$i18n.t('common.act_nbr')
    this.benef_PhoneNumber = this.$i18n.t('common.phn_nbr')
    this.benef_Address = this.$i18n.t('common.adrs')
    this.benef_City = this.$i18n.t('common.cty')
    this.benef_ZipCode = this.$i18n.t('common.zp_code')
    this.benef_Country = this.$i18n.t('common.ctry')
    this.benef_Selectazone = this.$i18n.t('zoneCodes.slct_zone')
    that.countries = this.$engine.bankAccounts.getZoneCode()
    that.zoneCode = ''
    let label = []
    // Ajout des labels pour le picker de la version mobile
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = that.$engine.bankAccounts.getZoneData(p.value[0])
      }
    })
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    addContact () {
      let that = this

      if (this.zone.accountNumberField == null) {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.account_zone')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.account_zone')})
        )
      }
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.accountLabel && this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        } else {
          // Account zone is mandatory
          this.$f7.alert(
              this.$i18n.t('errors.please_enter_mandatory',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
              this.$i18n.t('errors.missing_label',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
          )
          return
        }
      }

      if (this.identifier.length > 0 && this.typeContact === '1') {
        if (validateEmail(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.eml_adrs')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.eml_adrs')})
          )
          return
        }
      }
      if (this.identifier.length > 0 && this.typeContact === '2') {
        if (validateSIREN(this.identifier) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.srn')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.srn')})
          )
          return
        }
      }
      if (this.phoneNumber.length > 0) {
        if (validatePhoneNumber(this.phoneNumber) === null) {
          this.$f7.alert(
              this.$i18n.t('errors.change_to_valid',
                {invaliddata: this.$i18n.t('common.phn_nbr')}),
              this.$i18n.t('errors.invalid_data_format',
                {invaliddata: this.$i18n.t('common.phn_nbr')})
          )
          return
        }
      }
      if (that.name.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.nme')})
        )
        return
      }
      if (that.label.length === 0) {
        this.$f7.alert(
          '',
          this.$i18n.t('errors.missing_label',
            {invaliddata: this.$i18n.t('common.als')})
        )
        return
      }
      /* TLV 18/03/2020
      * Création d'un "faux IBAN" pour enregistrer en base
      */
      let localIban = createForeignIban(this.zone)

      // Edit contact
      // that.$f7.showPreloader('Adding contact')
      this.$engine.contacts.create({
        identifier: this.identifier,
        name: this.name,
        iban: localIban,
        label: this.label,
        phoneNumber: this.phoneNumber,
        address: this.address,
        city: this.city,
        zipCode: this.zipCode,
        country: this.country,
        typeContact: this.typeContact,
        zoneCode: this.zone.label
      })
      .then(() => {
        that.$f7.hidePreloader()
        that.$bus.$emit('refresh-cache-contacts')
        this.$f7.modal({
          title: this.$i18n.t('success.added_success', {data: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}),
          text: '<span class="preloader"></span>'
        })

        setTimeout(function () {
          that.$f7.closeModal()
          that.$$(document).off('taphold', '.testTap')
          loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        that.$f7.hidePreloader()
        this.handleError(err) // mixins errorHandlerMixins
      })

      that.$bus.$emit('refresh-cache-contacts')
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('typeInd')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
        } else {
          that.Dom7($event.target).next().hide()
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
        } else {
          that.Dom7($event.target).parent().next().hide()
        }
      }
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style scoped>

  ul {
    margin-left: -35px;
  }

</style>



// WEBPACK FOOTER //
// CMAddContact.vue?64b6ba28